(ns ui.page-components.filter-bar.sub
  (:require
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]
   [ui.components.filter.util :as filter-util]))


(rf/reg-sub
 ::all-filters
 (fn [db]
   (get db ::all-filters)))

(rf/reg-sub
 ::newly-added-filter
 (fn [db]
   (get db ::newly-added-filter)))

(rf/reg-sub
 ::filters
 (fn [db]
   (get db ::filters)))

(rf/reg-sub
 ::filter-configs
 :<-
 [::filters]
 (fn [filters [_ component-id]]
   (let [selected-filters (get filters component-id)]
     (->> selected-filters
          (map #(filter-util/resolve-filter-value @session/tenant @session/tenant-schema %))))))

(rf/reg-sub
 ::add-filter-options
 :<-
 [::all-filters]
 :<-
 [::filters]
 (fn [[all-filters filters] [_ component-id]]
   (->> (get all-filters component-id)
        (map (fn [{:keys [filter/key-path filter/label] :as filter}]
               {:value key-path
                :label label})))))

(rf/reg-sub
 ::default-filter
 :<-
 [::all-filters]
 :<-
 [::filters]
 (fn [[all-filters active-filters] [_ component-id]]
   (let [active-filter-kps (->> (get active-filters component-id)
                                (map :filter/key-path)
                                (set))
         next-filter (or (->> (get all-filters component-id)
                              (remove (fn [kp]
                                        (some #{(:filter/key-path kp)} active-filter-kps)))
                              (first))
                         (->> (get all-filters component-id)
                              (first)))]
     next-filter)))
